var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div><strong>AlgebraKiT</strong></div>\n<div>"
    + container.escapeExpression(__default(require("../../../../../util/handlebarsHelpers/__.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"An automatically generated task on the subject of {0} will appear here.",(depth0 != null ? lookupProperty(depth0,"subject") : depth0),{"name":"__","hash":{},"data":data,"loc":{"start":{"line":2,"column":5},"end":{"line":2,"column":93}}}))
    + "</div>\n";
},"useData":true});